import Vue from 'vue';

export default {
  // 交易公示列表接口
  getFormulaProjectList (params) {
    return Vue.axios.post('/api/v1.0/chanquan/notice/purchase/transactionAnnouncementList', params);
  },
  // 交易公示详情接口
  getFormulaProjectDetail (bidId) {
    return Vue.axios.get('/api/v1.0/chanquan/notice/purchase/getTransactionAnnouncementInfo/' + bidId);
  },
  // 交易公示 流转 详情接口
  getAuctionResults (projectId) {
    return Vue.axios.get('/api/v1.0/chanquan/project/getAuctionResultsAnnouncementContractInfo/' + projectId);
  },
  // 交易鉴证 列表接口
  tradingVerificationList (params) {
    return Vue.axios.post('/api/v1.0/chanquan/notice/purchase/tradingVerificationList', params);
  },
  // 交易鉴证 详情接口
  getTradingVerificationDetails (projectType, projectId, userId) {
    return Vue.axios.get('/api/v1.0/chanquan/notice/purchase/getTradingVerificationDetails?projectType=' +projectType + '&projectId=' +projectId + '&userId=' +userId);
  },
  // 批量项目公示列表
  getCentralizedTradingList (params) {
    return Vue.axios.post('/api/v1.0/chanquan/notice/purchase/centralizedTradingList', params);
  },
  // 批量项目鉴定列表
  batchTradingVerificationList (params) {
    return Vue.axios.post('/api/v1.0/chanquan/project/batch/batchTradingVerificationList', params);
  },
  // 批量项目公示详情
  getBatchdetails (id) {
    return Vue.axios.get('/api/v1.0/chanquan/project/batch/getBatchAuctionResultsAnnouncementContractInfo/'+id);
  },
  // 批量项目鉴定详情
  getBatchTradingVerificationDetails (projectId, projectType, userId) {
    return Vue.axios.get('/api/v1.0/chanquan/project/batch/getBatchTradingVerificationDetails?projectId=' +projectId + '&projectType=' +projectType+ '&userId=' +userId);
  }

};
